import { TableColum } from "../../interfaces";

const getColumnName = (column: TableColum, titleRow: string) => {
	if (titleRow && titleRow[column.field]) {
		return titleRow[column.field];
	}
	return column.name;
};

export default getColumnName;
